import React from 'react';
import PropTypes from 'prop-types';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import { Select } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { i18nMap } from '@bingads-webui-campaign/report-shared';
import _ from 'underscore';

function isReportTemplateType(type) {
  return _.includes([
    'ReportUITemplate',
    'ReportUICustomerTemplate',
    'ReportUIAccountTemplate',
    'ReportUIUserTemplate',
  ], type);
}

class FileFormatSelector extends React.Component {
  constructor(props) {
    super(props);
    const { Template } = props;
    this.fileFormat = undefined;
    if (isReportTemplateType(Template)) {
      this.fileFormat = i18nMap.FileFormatForReporting;
    } else {
      this.fileFormat = i18nMap.FileFormatForInlineDownload;
    }
  }

  render() {
    const {
      isScheduleEnabled, i18n, changeFileFormat, classes, fileFormat,
    } = this.props;

    const optionFactory = (selectorName, optionObj, useIndex = true) =>
      Object.entries(optionObj).map(([key, value], index) => (
        <option key={key} id={`${selectorName}Option-${useIndex ? index : key}`} value={useIndex ? index : key}>
          {value}
        </option>
      ));

    const optionsJSX = optionFactory('FileFormat', this.fileFormat, false);

    return (
      <React.Fragment>
        <div className={classes.fileFormatContainer} role="group" aria-labelledby="fileFormatLabel">
          <div id="fileFormatLabel" className={classes.fileFormatTitle}> {i18n.getString(_TL_('Format'))}</div>
          <Select
            disabled={!isScheduleEnabled}
            id="file-format-selector"
            value={fileFormat}
            onChange={e => changeFileFormat(e.target.value)}
            aria-labelledby="fileFormatLabel"
          >
            {optionsJSX}
          </Select>
        </div>
      </React.Fragment>);
  }
}

FileFormatSelector.propTypes = {
  isScheduleEnabled: PropTypes.bool.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  i18n: ReportingProps.i18n.isRequired,
  changeFileFormat: PropTypes.func.isRequired,
  fileFormat: PropTypes.string.isRequired,
  Template: PropTypes.string.isRequired,
};

const StyledFileFormatSelector = withDefaultStyles(FileFormatSelector, () => ({
  fileFormatContainer: {
    display: 'flex',
    flexFlow: 'column',
    '& .title': {
      alignSelf: 'top',
    },
    '& > div:first-child': {
      top: '-26px',
    },
  },
  fileFormatTitle: {
    marginTop: 8,
    marginBottom: 5,
  },
}));

export { StyledFileFormatSelector as FileFormatSelector };
